module.exports = __webpack_public_path__ + "static/media/IMG_8023.e764a44e.jpg";